import {
  backofficeClient,
  cacheClient,
  lpProcessorClient,
  processorClient,
  reportingClient,
} from '@/shared/graphql/client';

export const clients = {
  processor: processorClient,
  statechainCache: cacheClient,
  lpProcessor: lpProcessorClient,
  reportingService: reportingClient,
  backoffice: backofficeClient,
} as const;
export type Client = keyof typeof clients;
